import { Row, Col, Button, Form, Card } from 'react-bootstrap';
import { useEffect, useState, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

const ClubCard = ({ clubData, getClub, saveRef }) => {

  const { user: authUser } = useSelector(x => x.auth)
  const url = process.env.REACT_APP_URL

  const [type, setType] = useState('');
  const [name, setName] = useState('');
  const [slogan, setSlogan] = useState('');
  const [number, setNumber] = useState('');
  const [area, setArea] = useState('');
  const [division, setDivision] = useState('');
  const [district, setDistrict] = useState('');
  const [region, setRegion] = useState('');
  const [linkedIn, setLinkedIn] = useState('');
  const [linkedInVisible, setLinkedInVisible] = useState(false);
  const [facebook, setFacebook] = useState('');
  const [facebookVisible, setFacebookVisible] = useState(false);
  const [instagram, setInstagram] = useState('');
  const [instagramVisible, setInstagramVisible] = useState(false);
  const [x, setX] = useState('');
  const [xVisible, setXVisible] = useState(false);
  const [youtube, setYoutube] = useState('');
  const [youtubeVisible, setYoutubeVisible] = useState(false);

  useEffect(() => {
    if (clubData) {
      // console.log('clubData', clubData);
      setType(clubData.type || '');
      setName(clubData.name || '');
      setSlogan(clubData.slogan || '');
      setNumber(clubData.number || '');
      setArea(clubData.area || '');
      setDivision(clubData.division || '');
      setDistrict(clubData.district || '');
      setRegion(clubData.region || '');
      setLinkedIn(clubData.linkedIn || '');
      setLinkedInVisible(clubData.linkedInVisible || false);
      setFacebook(clubData.facebook || '');
      setFacebookVisible(clubData.facebookVisible || false);
      setInstagram(clubData.instagram || '');
      setInstagramVisible(clubData.instagramVisible || false);
      setX(clubData.x || '');
      setXVisible(clubData.xVisible || false);
      setYoutube(clubData.youtube || '');
      setYoutubeVisible(clubData.youtubeVisible || false);
    }
  }, [clubData]);

  const handleSubmit = useCallback(async (e) => {
    e?.preventDefault();
    const data = {
      "type": type,
      "name": name,
      "slogan": slogan,
      "number": number,
      "area": area,
      "division": division,
      "district": district,
      "region": region,
      "linkedIn": linkedIn,
      "linkedInVisible": linkedInVisible,
      "facebook": facebook,
      "facebookVisible": facebookVisible,
      "instagram": instagram,
      "instagramVisible": instagramVisible,
      "x": x,
      "xVisible": xVisible,
      "youtube": youtube,
      "youtubeVisible": youtubeVisible,
    };

    // console.log('Data to be sent:', JSON.stringify(data, null, 2)); // Log the data being sent

    try {
      const response = await fetch(`${url}/club`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authUser.token}`,
        },
        body: JSON.stringify(data),
      });

      if (response.ok) {
        // const result = await response.json();
        toast.success('Club updated successfully!', { position: 'bottom-left' });
        // console.log('Success:', result);
        getClub(); // Refresh the data
      } else {
        const errorResponse = await response.json();
        // console.error('Error response from server:', errorResponse);
        toast.error(`Failed to update Club! ${errorResponse.error || response.statusText}`, { position: 'bottom-left' });
      }
    } catch (error) {
      // console.error('Error updating Next Meeting:', error);
      toast.error(`Error updating Next Meeting! ${error.message}`, { position: 'bottom-left' });
    }
  },
    [type, name, slogan, number, area, division, district, region, linkedIn, linkedInVisible, facebook, facebookVisible, instagram, instagramVisible, x, xVisible, youtube, youtubeVisible, authUser.token, url, getClub]
  );

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.key === 's') {
        e.preventDefault();

        // Check if the active element is inside this card
        const cardElement = document.getElementById('club-card'); // Add a unique ID to the card
        if (cardElement && cardElement.contains(document.activeElement)) {
          handleSubmit(e); // Trigger handleSubmit only for this card
        }
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleSubmit]);

  useEffect(() => {
    if (saveRef) saveRef.current = handleSubmit;
  }, [saveRef, handleSubmit]);

  return (
    <Form data-bs-theme={'dark'}>
      <Card className="mb-3 shadow-sm">
        <Card.Header className="fw-semibold">Club details</Card.Header>
        <Card.Body>
          <Row className="g-3">
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Type</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Type"
                  className="formInput"
                  aria-label="Type"
                  name="type"
                  value={type}
                  onChange={(e) => setType(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12} md={6}>
              <Form.Group>
                <Form.Label>Name</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Name"
                  className="formInput"
                  aria-label="Name"
                  name="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>Slogan</Form.Label>
                <Form.Control
                  size="sm"
                  type="text"
                  placeholder="Speak. Connect. Grow."
                  className="formInput"
                  aria-label="Slogan"
                  name="slogan"
                  value={slogan}
                  onChange={(e) => setSlogan(e.target.value)}
                />
              </Form.Group>
            </Col>
            <Col xs={12}>
              <Row className="g-2">
                <Col xs={6} md>
                  <Form.Group>
                    <Form.Label>Number</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="Number"
                      className="formInput"
                      aria-label="Number"
                      name="number"
                      value={number}
                      onChange={(e) => setNumber(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md>
                  <Form.Group>
                    <Form.Label>Area</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="Area"
                      className="formInput"
                      aria-label="Area"
                      name="area"
                      value={area}
                      onChange={(e) => setArea(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md>
                  <Form.Group>
                    <Form.Label>Division</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="Division"
                      className="formInput"
                      aria-label="Division"
                      name="division"
                      value={division}
                      onChange={(e) => setDivision(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md>
                  <Form.Group>
                    <Form.Label>District</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="District"
                      className="formInput"
                      aria-label="District"
                      name="district"
                      value={district}
                      onChange={(e) => setDistrict(e.target.value)}
                    />
                  </Form.Group>
                </Col>
                <Col xs={6} md>
                  <Form.Group>
                    <Form.Label>Region</Form.Label>
                    <Form.Control
                      size="sm"
                      type="text"
                      placeholder="Region"
                      className="formInput"
                      aria-label="Region"
                      name="region"
                      value={region}
                      onChange={(e) => setRegion(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="mb-3 shadow-sm">
        <Card.Header className="fw-semibold">Social links</Card.Header>
        <Card.Body>
          <Row className="g-3">
            {[
              { label: 'LinkedIn', icon: 'bi bi-linkedin', value: linkedIn, setValue: setLinkedIn, visible: linkedInVisible, setVisible: setLinkedInVisible },
              { label: 'Facebook', icon: 'bi bi-facebook', value: facebook, setValue: setFacebook, visible: facebookVisible, setVisible: setFacebookVisible },
              { label: 'Instagram', icon: 'bi bi-instagram', value: instagram, setValue: setInstagram, visible: instagramVisible, setVisible: setInstagramVisible },
              { label: 'X', icon: 'bi bi-twitter-x', value: x, setValue: setX, visible: xVisible, setVisible: setXVisible },
              { label: 'Youtube', icon: 'bi bi-youtube', value: youtube, setValue: setYoutube, visible: youtubeVisible, setVisible: setYoutubeVisible },
            ].map((item) => (
              <Col xs={12} md={6} key={item.label}>
                <Form.Group>
                  <div className="d-flex align-items-center justify-content-between mb-1">
                    <Form.Label className="mb-0 d-inline-flex align-items-center gap-2">
                      <i className={item.icon} aria-hidden="true" />
                      <span>{item.label}</span>
                    </Form.Label>
                    <Form.Check
                      type="checkbox"
                      id={`${item.label.toLowerCase()}Visible`}
                      label="Visible"
                      checked={item.visible}
                      onChange={(e) => item.setVisible(e.target.checked)}
                    />
                  </div>
                  <Form.Control
                    size="sm"
                    type="text"
                    placeholder={item.label}
                    className="formInput"
                    aria-label={item.label}
                    value={item.value}
                    onChange={(e) => item.setValue(e.target.value)}
                  />
                </Form.Group>
              </Col>
            ))}
          </Row>
        </Card.Body>
      </Card>

      <Row className="mb-3">
        <Col xs={12} lg={12}>
          {!saveRef && (
            <Button variant="primary" className="float-end" onClick={handleSubmit}>
              <i className='bi bi-floppy'></i> Save
            </Button>
          )}
        </Col>
      </Row>
    </Form>
  );
};

export default ClubCard;